import { API } from 'aws-amplify';

export function getPollingData(_id, sessionId)
{
	return new Promise((resolve, reject) =>
	{
		API.get('pollingApi', `/getallpollings/${_id}/${sessionId}`)
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}